import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "../ui/button";
import { WHATSAPP_URL, IMAGES } from "../../lib/site-data";

export default function FinalCTA() {
    return (
        <section className="relative py-24 md:py-32 overflow-hidden" data-testid="final-cta-section">
            <div className="absolute inset-0">
                <img src={IMAGES.metallic} alt="" className="w-full h-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black"></div>
                <div className="absolute inset-x-0 top-1/2 h-px laser-line"></div>
            </div>

            <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16 text-center">
                <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-4">
                    Hazır mısınız?
                </p>
                <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight text-balance mb-5">
                    Kişisel ön değerlendirmeniz için{" "}
                    <span className="text-cyan-300 glow-cyan">bize ulaşın</span>
                </h2>
                <p className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto mb-10">
                    WhatsApp üzerinden fotoğraf gönderebilir veya site üzerindeki ön değerlendirme
                    formunu doldurabilirsiniz.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp">
                        <Button
                            size="lg"
                            className="bg-cyan-400 text-black hover:bg-cyan-300 font-medium px-8 py-6 shadow-[0_0_30px_rgba(0,240,255,0.3)]"
                        >
                            <MessageCircle className="h-5 w-5 mr-2" />
                            WhatsApp'tan Yaz
                        </Button>
                    </a>
                    <a href="#lead-form" data-testid="cta-form">
                        <Button
                            size="lg"
                            variant="outline"
                            className="bg-transparent border-white/20 text-white hover:bg-white/5 font-medium px-8 py-6"
                        >
                            Ön Değerlendirme Formu
                            <ArrowRight className="h-4 w-4 ml-2" />
                        </Button>
                    </a>
                </div>
            </div>
        </section>
    );
}
